import React from 'react'
import { useEffect, useState } from 'react'
import { SAlert, SDrawerOrModal } from 'shj-components'
import { Form, TreeSelect, Radio, Select } from 'antd'
import {
  getProductCategoryTreeList,
  getProductEnums,
  getSpecialCodesList,
} from '@/services/product'
import styles from './index.module.less'
import _ from 'lodash'

export default function ContentModal({
  onClose = () => {},
  submit = (a, b, c, d, e) => {},
  open = false,
  totalCount = 0,
}) {
  const [buttonLoading, setButtonLoading] = useState(false)
  const [categoryTree, setCategoryTree] = useState([])
  const [specialCodeList, setSpecialCodeList] = useState([])
  const [applyMaterialList, setApplyMaterialList] = useState([])
  const [form] = Form.useForm()

  useEffect(() => {
    fetchEnumData()
  }, [])

  const fetchEnumData = async () => {
    try {
      const productCategory: any = await getProductCategoryTreeList({
        enabled: true,
        modeFlags: [4],
      })
      const list: any = (await getSpecialCodesList({ data: {} })) || []
      const applyMaterialList: any = await getProductEnums(
        'com.shj.saas.plus.product.enums.ApplyMaterialSelection'
      )
      const specialCodeList = list.map((item: any) => {
        return { label: item.code + '-' + item.name, value: item.code }
      })
      setSpecialCodeList(specialCodeList)
      if (productCategory) {
        const newTree = formatTreeData(productCategory)
        setCategoryTree(newTree)
      }
      if (applyMaterialList?.length) {
        const list = applyMaterialList.map((item: any) => ({
          value: item.key,
          label: item.description,
        }))
        setApplyMaterialList(list)
        shopsControl(['NO_LIMIT'], list)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const formatTreeData = (list: any) => {
    return list.map((item: any) => {
      if (item?.children?.length) {
        return {
          ...item,
          children: formatTreeData(item?.children),
          selectable: false,
        }
      } else {
        return {
          ...item,
          selectable: true,
        }
      }
    })
  }

  const handleChangeCate = (_, node) => {
    if (node?.specialCode) {
      form.setFields([
        {
          name: 'specialCode',
          value: node.specialCode,
          errors: [],
        },
      ])
    }
  }

  const onSubmit = () => {
    form.validateFields().then(async (value: any) => {
      setButtonLoading(true)
      value?.applyMaterialSelections
      await submit(
        value?.id,
        value?.grossRate,
        value?.specialCode,
        value?.prodType,
        value?.applyMaterialSelections
      )
      setButtonLoading(false)
    })
  }

  const shopsControl = (value: any, list?: Array<any>) => {
    let newOption: any = _.cloneDeep(list || applyMaterialList)
    if (value?.length) {
      if (value.includes('NO_LIMIT')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.value !== 'NO_LIMIT',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.value === 'NO_LIMIT',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setApplyMaterialList(newOption)
  }
  return (
    <div className={styles.settlementQuotaConfig}>
      <SDrawerOrModal
        title={'选择产品分类'}
        mode="modal"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={buttonLoading}
        width="40%"
      >
        {totalCount > 0 && <SAlert type="info">将{totalCount}条施工库数据提交到产品库</SAlert>}

        <Form
          form={form}
          labelCol={{
            span: 12,
          }}
          style={{
            paddingTop: '12px',
          }}
          layout="vertical"
          name="basicInfo"
        >
          <Form.Item
            name="id"
            label="产品分类"
            rules={[
              {
                required: true,
                message: '请选择产品分类',
              },
            ]}
          >
            <TreeSelect
              placeholder="请选择产品分类"
              treeData={categoryTree}
              fieldNames={{
                label: 'cateName',
                value: 'id',
              }}
              onSelect={handleChangeCate}
              treeNodeFilterProp="cateName"
              showSearch
            />
          </Form.Item>
          <Form.Item
            label={'特项代码'}
            name={'specialCode'}
            rules={[
              {
                required: true,
                message: '请选择特项代码',
              },
            ]}
            extra="说明：物料/施工已有特项代码的，该位置可不选择，系统会自动同步特项代码"
          >
            <Select
              showArrow
              showSearch
              placeholder="请选择特项代码"
              options={specialCodeList}
              optionFilterProp="label"
            />
          </Form.Item>
          <Form.Item label={'产品类型'} name={'prodType'} initialValue={'PRODUCT_BASIC_ITEM'}>
            <Radio.Group
              options={[
                { value: 'PRODUCT_BASIC_ITEM', label: '基础项' },
                { value: 'PRODUCT_SINGLE', label: '单品' },
              ]}
            />
          </Form.Item>
          <Form.Item
            label={'适用选材'}
            name={'applyMaterialSelections'}
            initialValue={['NO_LIMIT']}
          >
            <Select
              showArrow
              showSearch
              placeholder="请选择适用选材"
              options={applyMaterialList}
              optionFilterProp="label"
              mode="multiple"
              onChange={(value, option) => {
                shopsControl(value)
              }}
            />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}
